import { UhcMediumHeader } from '@src/apps/styles/common-style';

export const buttonStyle: React.CSSProperties = {
  gap: 4,
  background: "#FFFFFF",
  padding: "0 8px",
  color: "#757588",
  fontFamily: UhcMediumHeader,
  fontStyle: "normal",
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: 0,
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 40,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
};

export const iconStyle: React.CSSProperties = {
  width: 24,
  height: 24,
  minWidth: 24,
  minHeight: 24,
  flexShrink: 0,
  display: 'block',
  color: '#757588',
  alignSelf: 'center',
};

export const contentEditorStyles: Record<string, React.CSSProperties> = {
  wrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  triggerLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  triggerIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    lineHeight: 0,
    flexShrink: 0,
  },
  dropdownMenu: {
    position: 'absolute',
    top: '44px',
    right: 0,
    background: '#FFFFFF',
    borderRadius: 4,
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
    zIndex: 10001,
    minWidth: 200,
    padding: '8px 0',
  },
  dropdownMenuPortal: {
    position: 'fixed',
    left: 'auto',
    background: '#FFFFFF',
    borderRadius: 4,
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.15)',
    zIndex: 10001,
    minWidth: 200,
    padding: '8px 0',
  },
  dropdownColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdownHeader: {
    padding: '8px 16px 4px 16px',
  },
  dropdownHeaderText: {
    fontFamily: '"UHCSans-SemiBold", Helvetica, Arial, Verdana, Tahoma, sans-serif',
    fontSize: 14,
    color: '#757588',
    letterSpacing: 0,
  },
  dropdownLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  dropdownItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdownLink: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px 16px',
    textAlign: 'left',
    width: '100%',
  },
  dropdownItemText: {
    fontFamily: '"UHCSans-Medium", Helvetica, Arial, Verdana, Tahoma, sans-serif',
    fontSize: 14,
    color: '#757588',
    letterSpacing: 0,
  },
  dropdownItemTextHover: {
    textDecoration: 'underline',
    textDecorationColor: '#757588',
  },
  dropdownItemTextDefault: {
    textDecoration: 'none',
    textDecorationColor: '',
  },
};
